var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"label":"Course Location","item-value":"ID","item-text":"name","loading":_vm.loading,"items":_vm.items},on:{"input":_vm._valueClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }